import { PackagePlus } from 'lucide-react';

/**
 * Empty states parc Matériels V2.
 * @param {'parc'|'filtre'|'section'} variant
 */
export default function MaterielEmptyState({
  variant = 'parc',
  onPrimary,
  onSecondary,
  primaryLabel,
  secondaryLabel = 'Réinitialiser les filtres',
  className = '',
}) {
  const copy =
    variant === 'filtre'
      ? {
          title: 'Aucun résultat',
          text: 'Aucun matériel ne correspond à cette recherche ou à ces filtres.',
          cta: secondaryLabel,
          action: onSecondary,
        }
      : variant === 'section'
        ? {
            title: 'Aucun matériel dans cette section',
            text: 'Modifiez les filtres ou ajoutez un appareil au parc.',
            cta: primaryLabel || null,
            action: onPrimary,
          }
        : {
            title: 'Aucun matériel enregistré',
            text: 'Ajoutez votre premier appareil pour constituer le parc Clickorico. Vous pourrez ensuite l’affecter à un point de vente.',
            cta: primaryLabel || 'Ajouter votre premier matériel',
            action: onPrimary,
          };

  return (
    <div
      className={`bg-white border border-gray-200 rounded-lg px-6 py-12 text-center ${className}`}
    >
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-50 text-primary-600">
        <PackagePlus className="h-6 w-6" aria-hidden />
      </div>
      <h3 className="mt-4 text-sm font-semibold text-gray-900">{copy.title}</h3>
      <p className="mt-1 text-sm text-gray-500 max-w-md mx-auto">{copy.text}</p>
      {copy.cta && typeof copy.action === 'function' ? (
        <button
          type="button"
          onClick={copy.action}
          className="mt-5 inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
        >
          {variant === 'parc' || variant === 'section' ? `+ ${copy.cta.replace(/^\+\s*/, '')}` : copy.cta}
        </button>
      ) : null}
    </div>
  );
}
